const { getObjectValue } = require('@root/helpers');

module.exports = {
	messages: (state) => (
		type,
		page = null,
		perPage = 5,
		sorting = null,
		searchQuery = null
	) => {
		let messages = state.messages;

		if (type === 'sent') {
			messages = state.sent_messages;
		}

		if (searchQuery) {
			searchQuery = searchQuery.toLowerCase();

			messages = _.filter(messages, function(message) {
				return (
					getObjectValue('from.name', message, '')
						.toLowerCase()
						.indexOf(searchQuery) >= 0 ||
					getObjectValue('body', message, '')
						.toLowerCase()
						.indexOf(searchQuery) >= 0
				);
			});
		}

		messages = _.filter(messages, function(message) {
			if (type === 'archived') {
				return (
					getObjectValue('pivot.archived_at', message, undefined) !==
					null
				);
			} else if (type === 'read') {
				return (
					getObjectValue('pivot.read_at', message, undefined) !== null &&
					getObjectValue('pivot.archived_at', message, undefined) == null
				);
			} else if (type === 'unread') {
				return (
					getObjectValue('pivot.read_at', message, undefined) === null
				);
			}

			return true;
		});

		if (sorting !== null) {
			messages = _.orderBy(messages, sorting.orderby, sorting.order);
		}

		if (page) {
			return _.chunk(messages, perPage)[page - 1];
		}

		if (!messages) {
			messages = [];
		}

		return messages;
	},

	recipients: (state) => state.recipients,
};
